var BxfBadgeSizeEnum;
(function (BxfBadgeSizeEnum) {
    BxfBadgeSizeEnum["PINPOINT"] = "pinpoint";
    BxfBadgeSizeEnum["SMALL"] = "small";
    BxfBadgeSizeEnum["LARGE"] = "large";
})(BxfBadgeSizeEnum || (BxfBadgeSizeEnum = {}));

var BxfBadgeStyleEnum;
(function (BxfBadgeStyleEnum) {
    BxfBadgeStyleEnum["NEUTRAL"] = "neutral";
    BxfBadgeStyleEnum["ALERT"] = "alert";
    BxfBadgeStyleEnum["ERROR"] = "error";
    BxfBadgeStyleEnum["WARNING"] = "warning";
    BxfBadgeStyleEnum["SUCCESS"] = "success";
    BxfBadgeStyleEnum["NEW"] = "new";
    BxfBadgeStyleEnum["IN_PROGRESS"] = "in_progress";
})(BxfBadgeStyleEnum || (BxfBadgeStyleEnum = {}));

var BxfBadgeTypeEnum;
(function (BxfBadgeTypeEnum) {
    BxfBadgeTypeEnum["NUMBER"] = "number";
    BxfBadgeTypeEnum["TEXT"] = "text";
    BxfBadgeTypeEnum["ICON"] = "icon";
    BxfBadgeTypeEnum["TEXT_WITH_ICON"] = "text_with_icon";
    BxfBadgeTypeEnum["CUSTOM"] = "custom";
})(BxfBadgeTypeEnum || (BxfBadgeTypeEnum = {}));

var BxfBadgeWeightEnum;
(function (BxfBadgeWeightEnum) {
    BxfBadgeWeightEnum["BOLD"] = "bold";
    BxfBadgeWeightEnum["SUBTLE"] = "subtle";
    BxfBadgeWeightEnum["ALTERNATIVE"] = "alternative";
    BxfBadgeWeightEnum["SUBTLE_ALTERNATIVE"] = "subtle-alternative";
})(BxfBadgeWeightEnum || (BxfBadgeWeightEnum = {}));

class BxfBadgeConstants {
    static STRING = {
        BADGE: 'bxf-badge',
        BADGE_VALUE_TEXT_WITH_ICON: 'bxf-badge__text-with-icon-value',
        BADGE_WARNING_SUBTLE_BACKGROUND: 'bxf-badge--warning-background-subtle',
        BADGE_WARNING_BOLD_BACKGROUND: 'bxf-badge--warning-background-bold',
        BADGE_EMPTY_BACKGROUND: 'bxf-badge--empty-background',
        BADGE_ICON_BACKGROUND: 'bxf-badge--icon-background',
        BADGE_TEXT_WITH_ICON_BACKGROUND: 'bxf-badge--text-with-icon-background',
        BADGE_CONTENT_TEXT_PINPOINT: 'bxf-badge__text-content--pinpoint',
        BADGE_VALUE_TEXT_PINPOINT: 'bxf-badge__text-value--pinpoint',
        ICON_NEUTRAL: 'info',
        ICON_ALERT: 'alert',
        ICON_ERROR: 'error',
        ICON_NEW: 'new',
        ICON_IN_PROGRESS: 'inprogress',
        ICON_VIEWBOX_SMALL: '0 0 16 16',
        ICON_VIEWBOX_LARGE: '0 0 24 24',
        NUMBER_OVERFLOW_VALUE: '999+',
        NEUTRAL: 'Neutral',
        ALERT: 'Alert',
        ERROR: 'Error',
        WARNING: 'Warning',
        SUCCESS: 'Success',
        NEW: 'New',
        IN_PROGRESS: 'In Progress',
        CONTENT: 'bxf-badge--content',
    };
}

export { BxfBadgeSizeEnum as B, BxfBadgeStyleEnum as a, BxfBadgeTypeEnum as b, BxfBadgeWeightEnum as c, BxfBadgeConstants as d };
